import {
  ArrowUpDownIcon,
  BedDoubleIcon,
  Building2Icon,
  CalendarDaysIcon,
  ChartGanttIcon,
  FileTextIcon,
  FootprintsIcon,
  Grid3x3Icon,
  KeyRoundIcon,
  LayoutDashboardIcon,
  LayoutGridIcon,
  ListChecksIcon,
  ListTreeIcon,
  PanelRightIcon,
  PanelsLeftRightIcon,
  PencilLineIcon,
  ServerIcon,
  SettingsIcon,
  TableIcon,
  UsersIcon,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  label: string;
  path: string;
  icon: LucideIcon;
  /** 이 메뉴에 속하지만 경로가 다른 화면 — 그 화면에서도 메뉴를 활성으로 표시한다. */
  alsoActiveOn?: string[];
}

export interface NavSection {
  label?: string;
  items: NavItem[];
}

/** 현재 지원하는 업무 진입만 표시한다. */
export const NAV_SECTIONS: NavSection[] = [
  {
    label: '운영',
    items: [
      {
        label: '지점',
        path: '/properties',
        icon: Building2Icon,
      },
      { label: '출입 관리', path: '/access', icon: KeyRoundIcon },
      { label: '투숙 현황', path: '/stays', icon: BedDoubleIcon },
      { label: '사용자 관리', path: '/users', icon: UsersIcon },
      { label: '개인 예약', path: '/contracts', icon: FileTextIcon },
    ],
  },
];

/** 개발 서버에서만 표시하는 UI 패턴 견본(더미 데이터) 메뉴 — 라우트는 /dev 아래에 있다. */
export const DEV_NAV_SECTIONS: NavSection[] = [
  {
    label: '패턴 견본',
    items: [{ label: '대시보드', path: '/dev', icon: LayoutDashboardIcon }],
  },
  {
    label: '목록',
    items: [
      { label: '데이터 리스트', path: '/dev/list', icon: TableIcon },
      { label: '리스트 + 패널', path: '/dev/master-detail', icon: PanelRightIcon },
      { label: '일괄 처리', path: '/dev/bulk', icon: ListChecksIcon },
      { label: '서버 연동 목록', path: '/dev/server-list', icon: ServerIcon },
      { label: '순서 편집', path: '/dev/sortable', icon: ArrowUpDownIcon },
    ],
  },
  {
    label: '입력·편집',
    items: [
      { label: '인라인 편집 표', path: '/dev/inline-edit', icon: PencilLineIcon },
      { label: '스프레드시트 뷰', path: '/dev/spreadsheet', icon: Grid3x3Icon },
      { label: '탭 + 설정 폼', path: '/dev/settings', icon: SettingsIcon },
      { label: '다단계 위저드', path: '/dev/wizard', icon: FootprintsIcon },
      { label: '편집기 + 미리보기', path: '/dev/editor', icon: PanelsLeftRightIcon },
      { label: '권한 트리', path: '/dev/permission-tree', icon: ListTreeIcon },
    ],
  },
  {
    label: '보기',
    items: [
      { label: '타임라인 뷰', path: '/dev/timeline', icon: ChartGanttIcon },
      { label: '이벤트 캘린더', path: '/dev/event-calendar', icon: CalendarDaysIcon },
      { label: '매트릭스·히트맵', path: '/dev/matrix', icon: LayoutGridIcon },
    ],
  },
];

export function isActivePath(pathname: string, path: string) {
  if (path === '/' || path === '/dev') {
    return pathname === path;
  }
  return pathname === path || pathname.startsWith(`${path}/`);
}

export function isNavItemActive(pathname: string, item: NavItem) {
  return (
    isActivePath(pathname, item.path) ||
    (item.alsoActiveOn ?? []).some((path) => isActivePath(pathname, path))
  );
}
